import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  effect, inject,
  Input,
  input
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../../../../core/services/language.service';
import { IconComponent } from '../../../../../osp-ui/components/icon/icon/icon.component';
import { TagSeverity } from '../../../../../osp-ui/components/misc/tag/contract/tag-severity.contract';
import { TagComponent } from '../../../../../osp-ui/components/misc/tag/tag.component';
import { TooltipDirective } from '../../../../../osp-ui/components/overlay/tooltip/tooltip.directive';
import { ComponentSize } from '../../../../../osp-ui/enums/component-size.enum';
import {
  EquipmentAttentionStatus
} from '../equipments-details/components/events/enums/equipment-attention-status.enum';
import { IconProviderService } from '../../../../../whitelabel/services/icon-provider.service';
import { IconKey } from '../../../../../../whitelabel/icon-key.enum';

@Component({
  selector: 'osp-attention-status-tag',
  standalone: true,
  imports: [TagComponent, TooltipDirective, IconComponent, TranslateModule],
  templateUrl: './attention-status-tag.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})

export class AttentionStatusTagComponent {

  // we have to use an input signal here, because $currentEquipment() is a signal itself which changes from null to an equipment. If we don't use
  // input signal here, we don't receive the updated equipment and this won't render properly.
  status = input<EquipmentAttentionStatus | undefined>(undefined);
  @Input() size: ComponentSize = ComponentSize.LARGE;

  protected readonly iconProviderService = inject(IconProviderService);
  protected icon: string = '';
  protected severity: TagSeverity = 'info';
  protected class: string = '';
  protected tooltip: string = '';
  protected label: string = 'unknown';
  protected readonly ComponentSize = ComponentSize;


  constructor(protected languageService: LanguageService, private cdr: ChangeDetectorRef,) {

    effect(() => {

      switch (this.status()) {

        case EquipmentAttentionStatus.GOOD: {
          this.icon = this.iconProviderService.getIcon(IconKey.AttentionStatusGood);
          this.severity = 'success';
          this.label = this.languageService.getInstant('shared.pipes.attentionStatus.good');
          this.tooltip = this.languageService.getInstant('revolution.modules.equipment.equipmentDetails.attentionStatus.tooltip.good');
          break;
        }

        case EquipmentAttentionStatus.MACHINE_FAULT: {
          this.icon = this.iconProviderService.getIcon(IconKey.AttentionStatusMachineFault);
          this.severity = 'warning';
          this.label = this.languageService.getInstant('shared.pipes.attentionStatus.machineFault');
          this.tooltip = this.languageService.getInstant('revolution.modules.equipment.equipmentDetails.attentionStatus.tooltip.machineFault');
          break;
        }

        case EquipmentAttentionStatus.MAINTENANCE_DUE: {
          this.icon = this.iconProviderService.getIcon(IconKey.AttentionStatusMaintenanceDue);
          this.severity = 'warning';
          this.label = this.languageService.getInstant('shared.pipes.attentionStatus.maintenanceDue');
          this.tooltip = this.languageService.getInstant('revolution.modules.equipment.equipmentDetails.attentionStatus.tooltip.maintenanceDue');
          break;
        }

        case EquipmentAttentionStatus.MACHINE_FAULT_AND_MAINTENANCE_DUE: {
          this.icon = this.iconProviderService.getIcon(IconKey.AttentionStatusMachineFaultAndMaintenanceDue);
          this.severity = 'danger';
          this.label = this.languageService.getInstant('shared.pipes.attentionStatus.machineFaultAndMaintenanceDue');
          this.tooltip = this.languageService.getInstant('revolution.modules.equipment.equipmentDetails.attentionStatus.tooltip.machineFaultAndMaintenanceDue');
          break;
        }

        default: {
          break;
        }
      }

      // we need this line to make the component work outside the $currentEquipment() scope
      this.cdr.detectChanges();

    });
  }

}
